














import Vue from 'vue';

export default Vue.extend({
  name: 'SideTabs',
  props: {
    current: String,
  },
  components: {
  },
  data() {
    return {
      menu: [
        { name: 'top', text: 'マイページ', to: '/mypage'},
        { name: 'mydeals', text: '取引管理', to: '/mypage/deals' },
        { name: 'sales', text: '売上管理', to: '/mypage/payouts' },
        { name: 'settings', text: '各種設定', to: '/mypage/settings' },
      ]
    }
  },
  computed: {
  },
  methods: {
  }
})
